"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_intelligence__scan__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "f6384cd7-fe8c-4f27-a5df-25dca5a17e55",
    x1: 96.05,
    y1: 4.98,
    x2: 96.05,
    y2: 576.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c9c9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab2dc4b4-69ca-4a30-9049-f5ee610cc971",
    x1: 96.05,
    y1: 2.42,
    x2: 96.05,
    y2: 115.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2b48ea82-0e2d-41d4-bcc5-e720173988e9",
    x1: 96.05,
    y1: 22.52,
    x2: 96.05,
    y2: 90.85,
    xlinkHref: "#ab2dc4b4-69ca-4a30-9049-f5ee610cc971"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "43c03838-ee38-431a-9982-434ea868fe46",
    x1: 10935.7,
    y1: -2848.76,
    x2: 10935.7,
    y2: -2838.94,
    gradientTransform: "translate(11013.2 -2754.29) rotate(180)",
    xlinkHref: "#ab2dc4b4-69ca-4a30-9049-f5ee610cc971"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bbd7f37a-cceb-4722-9203-a96fbd6581f3",
    x1: 10897.96,
    y1: -2848.76,
    x2: 10897.96,
    y2: -2838.94,
    gradientTransform: "translate(11013.2 -2754.29) rotate(180)",
    xlinkHref: "#ab2dc4b4-69ca-4a30-9049-f5ee610cc971"
  })), /*#__PURE__*/React.createElement("title", null, "intelligence-scan-hi-dark"), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "737f05ab-0596-44c2-b4be-3f50e7236d3d",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,56a4,4,0,0,1-4-4V28a4,4,0,0,1,4-4H52a4,4,0,0,1,0,8H32V52A4,4,0,0,1,28,56Z",
    transform: "translate(0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,53.67a4,4,0,0,1-4-4V52a4,4,0,0,0,8,0V49.67A4,4,0,0,1,28,53.67Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,29.67H32V32H52a4,4,0,0,0,4-4,4.09,4.09,0,0,0-.19-1.17A4,4,0,0,1,52,29.67Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52,168H28a4,4,0,0,1-4-4V140a4,4,0,0,1,8,0v20H52a4,4,0,0,1,0,8Z",
    transform: "translate(0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,165.83H28a4,4,0,0,1-4-4V164a4,4,0,0,0,4,4H52a4,4,0,0,0,4-4,3.81,3.81,0,0,0-.17-1.08A4,4,0,0,1,52,165.83Z",
    transform: "translate(0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,56a4,4,0,0,1-4-4V32H140a4,4,0,0,1,0-8h24a4,4,0,0,1,4,4V52A4,4,0,0,1,164,56Z",
    transform: "translate(0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164,53.67a4,4,0,0,0,4-4V52a4,4,0,0,1-8,0V49.67A4,4,0,0,0,164,53.67Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,29.67h20V32H140a4,4,0,0,1-4-4,4.09,4.09,0,0,1,.19-1.17A4,4,0,0,0,140,29.67Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164,168H140a4,4,0,0,1,0-8h20V140a4,4,0,0,1,8,0v24A4,4,0,0,1,164,168Z",
    transform: "translate(0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,165.83h24a4,4,0,0,0,4-4V164a4,4,0,0,1-4,4H140a4,4,0,0,1-4-4,3.81,3.81,0,0,1,.17-1.08A4,4,0,0,0,140,165.83Z",
    transform: "translate(0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,57c4.41,10.15,5.08,23.22,3,33.44,7.43.49,4,16.69-1.82,25.55-2.2,3.39-4.6,3.76-6.53,3.54-2.11,25.74-21.88,40.5-36.53,40.5s-34.43-14.76-36.54-40.5c-1.93.22-4.33-.15-6.54-3.53-5.78-8.87-9.25-25.07-1.81-25.56-2.12-10.22-1.45-23.29,3-33.44,0,0,9.15-25,41.92-25S138,57,138,57Z",
    transform: "translate(0)",
    fill: "url(#f6384cd7-fe8c-4f27-a5df-25dca5a17e55)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.79,94c.19,5.64-2.47,13.85-6,19.3-2.18,3.38-4.56,3.76-6.48,3.53-2.1,25.75-21.71,40.5-36.25,40.5S61.89,142.54,59.8,116.8c-1.92.22-4.3-.16-6.49-3.54-3.53-5.45-6.18-13.66-6-19.3-1.48,5.37,1.48,15.6,5.66,22,2.21,3.38,4.61,3.75,6.54,3.53C61.63,145.24,81.4,160,96.06,160s34.42-14.76,36.53-40.5c1.93.22,4.33-.15,6.53-3.54C143.3,109.56,146.27,99.33,144.79,94Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138,57S128.81,32,96,32,54.12,57,54.12,57c-4.4,10.14-5,23.3-2.94,33.52,2.76-.58,9.17-3.17,9.27-14.66.13-14.63,8.71-22,19.93-18.3a49.44,49.44,0,0,0,30.84,0c11.2-3.74,19.8,3.67,19.93,18.3.11,12.3,7.44,14.4,9.79,14.76C143.05,80.38,142.37,67.1,138,57Z",
    transform: "translate(0)",
    fill: "url(#ab2dc4b4-69ca-4a30-9049-f5ee610cc971)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.71,75.83c.12-14.63,8.7-22,19.92-18.3a49.44,49.44,0,0,0,30.84,0c11.21-3.74,19.81,3.67,19.93,18.3v-2c-.12-16.66-8.12-23.43-19.93-20.84a69.81,69.81,0,0,1-30.84,0c-11.18-2.11-19.8,4.18-19.92,20.84Z",
    transform: "translate(0)",
    opacity: 0.38,
    fill: "url(#2b48ea82-0e2d-41d4-bcc5-e720173988e9)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.88,94.36a11,11,0,0,0-1.31-1.73l.3.31a17.27,17.27,0,0,0-7-4.94h0A16.45,16.45,0,0,0,81,87.2l-.24,0c-.41-.07-.84-.13-1.28-.18l-.35,0c-.52,0-1.06-.08-1.61-.08h-.08c-.52,0-1,0-1.51.07l-.54.06c-.33,0-.64.08-1,.13l-.57.1c-.34.06-.66.14-1,.23s-.57.15-.84.24l-.62.2-.68.26-.4.18a16.79,16.79,0,0,0-7.23,6,.76.76,0,0,0,0,.59s.17.28.4.6h0l.1.14.1.14.26.33.12.14c.28.34.63.73,1,1.13l.19.18.47.44.26.23.5.42.31.23.58.42.31.22.76.48.23.14c.35.2.71.39,1.1.57l.26.12c.3.13.61.27.93.39l.44.16.86.28.52.14c.16,0,.33.08.49.12a6.5,6.5,0,1,1,8.35,0l.5-.12a4.61,4.61,0,0,0,.53-.15c.29-.08.56-.17.84-.27l.47-.17c.29-.11.57-.23.85-.36l.34-.15c.38-.18.74-.37,1.09-.57l.15-.09.84-.52.32-.23.57-.41.32-.25.47-.39.29-.25.42-.4.24-.22.4-.42.15-.16c.17-.18.32-.36.46-.52l.13-.17.24-.29.14-.19.09-.12h0c.21-.29.33-.48.36-.52A.78.78,0,0,0,91.88,94.36Z",
    transform: "translate(0)",
    opacity: 0.23,
    fill: "url(#43c03838-ee38-431a-9982-434ea868fe46)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.62,94.36a11.83,11.83,0,0,0-1.31-1.73l.29.31a17.15,17.15,0,0,0-7-4.94h0a16.45,16.45,0,0,0-2.83-.79l-.24,0c-.41-.07-.84-.13-1.28-.18l-.35,0c-.53,0-1.06-.08-1.62-.08h-.08c-.51,0-1,0-1.5.07l-.54.06c-.33,0-.65.08-1,.13l-.56.1c-.34.06-.67.14-1,.23s-.57.15-.85.24l-.61.2-.68.26-.41.18a16.72,16.72,0,0,0-7.22,6,.76.76,0,0,0,0,.59s.16.28.39.6h0l.11.14.1.14.26.33.12.14a14,14,0,0,0,1,1.13l.18.18.48.44.26.23.5.42.3.23.58.42.32.22.76.48.23.14c.35.2.71.39,1.09.57l.27.12c.3.13.6.27.92.39l.45.16.86.28.51.14.5.12a6.5,6.5,0,1,1,8.34,0c.17,0,.34-.07.5-.12a4.77,4.77,0,0,0,.54-.15c.29-.08.56-.17.83-.27l.47-.17c.3-.11.58-.23.86-.36l.34-.15q.57-.27,1.08-.57l.16-.09c.29-.17.57-.35.83-.52l.32-.23c.2-.13.39-.27.57-.41l.32-.25.48-.39L127,98l.42-.4.23-.22.41-.42.15-.16c.17-.18.32-.36.46-.52l.13-.17.24-.29.14-.19.09-.12h0l.37-.52A.78.78,0,0,0,129.62,94.36Z",
    transform: "translate(0)",
    opacity: 0.23,
    fill: "url(#bbd7f37a-cceb-4722-9203-a96fbd6581f3)",
    style: {
      mixBlendMode: "multiply"
    }
  }))));
}

var _default = ic_intelligence__scan__dark;
exports.default = _default;